import styled from "styled-components";

const HeaderContainer = styled.div`
padding-bottom : 20px;
`;
export default HeaderContainer;